import React from 'react';
import { ListEmpty } from 'components';
import { TABLE_EMPTY_STATE_WITHOUT_BORDERS } from 'constants/images';
import {} from './CompanyContactsTableEmptyState.types';
const CompanyContactsTableEmptyState = ({ content }) => (React.createElement(ListEmpty, { content: content, image: TABLE_EMPTY_STATE_WITHOUT_BORDERS, message: React.createElement("span", { className: "text-lg text-grey-70 leading-6" }, "This company doesn't have contacts added yet") }));
export default CompanyContactsTableEmptyState;
